import script from "./FixRep.vue?vue&type=script&setup=true&lang=ts"
export * from "./FixRep.vue?vue&type=script&setup=true&lang=ts"

import "./FixRep.vue?vue&type=style&index=0&id=0877d738&lang=css"

const __exports__ = script;

export default __exports__